import { themeColors } from "../components/chartTheme";

/**
 * Returns the zone color for a breathing rate value.
 * <12 = AMBER, 12-18 = GREEN, 19-20 = AMBER, >20 = RED
 */
export const getBreathingRateColor = (value: number): string => {
  if (value < 12) {
    return themeColors.warning;
  }
  if (value >= 12 && value <= 18) {
    return themeColors.success;
  }
  if (value >= 19 && value <= 20) {
    return themeColors.warning;
  }
  return themeColors.error;
};
